import { render, staticRenderFns } from "./mss-hyrox-avtice.component.vue?vue&type=template&id=77f3d1d2"
import script from "./mss-hyrox-avtice.component.ts?vue&type=script&lang=ts&external"
export * from "./mss-hyrox-avtice.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports